// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#form-login-component {
  width: 100%;
  max-width: 25rem;
  max-height: 100%;
  animation: opacity_start 0.6s 1;
}
#form-login-component .carousel-content {
  width: 100%;
  position: absolute;
  padding: 0 0.3rem;
  height: fit-content;
  opacity: 0;
  transform: translateY(-10rem);
  pointer-events: none;
}
#form-login-component .carousel-content.visible-content {
  opacity: 1;
  transform: translateY(0rem);
  pointer-events: all;
  animation: opacity_entry 0.6s 1;
}
#form-login-component .login-activation-type-card {
  padding: 1.75rem;
  cursor: pointer;
  position: relative;
}
#form-login-component .login-activation-type-card::after {
  content: '';
  position: absolute;
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -1;
  border-radius: 1.25rem;
  background-color: var(--primary-color);
  transition: 0.3s;
}
#form-login-component .login-activation-type-card .anticon {
  transition: 0.6s;
}
#form-login-component .login-activation-type-card b {
  transition: 0.6s;
}
#form-login-component .login-activation-type-card:hover::after,
#form-login-component .login-activation-type-card.selected::after {
  width: 100%;
  opacity: 1;
}
#form-login-component .login-activation-type-card:hover .anticon,
#form-login-component .login-activation-type-card.selected .anticon {
  color: var(--primary-text-color) !important;
}
#form-login-component .login-activation-type-card:hover b,
#form-login-component .login-activation-type-card.selected b {
  color: var(--primary-text-color);
}
@media (min-width: 768px) {
  #form-login-component {
    position: relative;
    display: flex;
    align-items: center;
  }
  #form-login-component .carousel-content {
    animation: right_opacity_exit 0.6s 1;
  }
  #form-login-component .carousel-content.visible-content {
    animation: right_opacity_entry 0.6s 1;
  }
}
@media (max-width: 768px) {
  #form-login-component {
    padding: 1.4rem 0;
  }
  #form-login-component .carousel-content {
    padding: 0 1rem;
    height: 0;
    overflow: hidden;
  }
  #form-login-component .carousel-content.visible-content {
    position: inherit;
    height: fit-content;
  }
}
#form-login-component .password-step-divider {
  border-top-color: #cccccc;
}
#form-login-component .password-step-divider .ant-divider-inner-text {
  font-weight: 500;
  font-size: 0.875rem;
}
@keyframes opacity_start {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes opacity_entry {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes right_opacity_entry {
  0% {
    opacity: 0;
    transform: translateX(11rem);
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateX(0rem);
  }
}
@keyframes right_opacity_exit {
  0% {
    opacity: 1;
    transform: translateX(0rem);
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translateX(-11rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/LogInScreen/styles.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EAEA,+BAAA;AAAF;AALA;EAQI,WAAA;EACA,kBAAA;EAEA,iBAAA;EACA,mBAAA;EAEA,UAAA;EACA,6BAAA;EACA,oBAAA;AAFJ;AAII;EACE,UAAA;EACA,2BAAA;EACA,mBAAA;EAEA,+BAAA;AAHN;AApBA;EA4BI,gBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AAOI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,sCAAA;EAEA,gBAAA;AANN;AAtCA;EAgDM,gBAAA;AAPN;AAzCA;EAoDM,gBAAA;AARN;AAaM;;EACE,WAAA;EACA,UAAA;AAVR;AAMI;;EAQI,2CAAA;AAVR;AAEI;;EAYI,gCAAA;AAVR;AAeE;EAAA;IACE,kBAAA;IACA,aAAA;IACA,mBAAA;EAZF;EASA;IAMI,oCAAA;EAZJ;EAcI;IACE,qCAAA;EAZN;AACF;AAgBE;EAAA;IACE,iBAAA;EAbF;EAYA;IAII,eAAA;IAEA,SAAA;IACA,gBAAA;EAdJ;EAgBI;IACE,iBAAA;IACA,mBAAA;EAdN;AACF;AApFA;EAuGI,yBAAA;AAhBJ;AAvFA;EA0GM,gBAAA;EACA,mBAAA;AAhBN;AAqBA;EACE;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;AACF;AAqBA;EACE;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;AACF;AAqBA;EACE;IACE,UAAA;IACA,4BAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;IACA,2BAAA;EAnBF;AACF;AAqBA;EACE;IACE,UAAA;IACA,2BAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;IACA,6BAAA;EAnBF;AACF","sourcesContent":["#form-login-component{\n  width: 100%;\n  max-width: 25rem;\n  max-height: 100%;\n\n  animation: opacity_start .6s 1;\n\n  .carousel-content {\n    width: 100%;\n    position: absolute;\n\n    padding: 0 .3rem;\n    height: fit-content;\n\n    opacity: 0;\n    transform: translateY(-10rem);\n    pointer-events: none;\n    \n    &.visible-content {\n      opacity: 1;\n      transform: translateY(0rem);\n      pointer-events: all;\n\n      animation: opacity_entry .6s 1;\n    }\n  }\n\n  .login-activation-type-card {\n    padding: 1.75rem;\n    cursor: pointer;\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 100%;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      z-index: -1;\n      border-radius: @border-radius;\n      background-color: var(--primary-color);\n    \n      transition: .3s;\n    }\n\n    .anticon {\n      transition: .6s;\n    }\n    \n    b {\n      transition: .6s;\n    }\n\n    &:hover,\n    &.selected {\n      &::after {\n        width: 100%;\n        opacity: 1;\n      }\n\n      .anticon {\n        color: var(--primary-text-color) !important;\n      }\n\n      b {\n        color: var(--primary-text-color);\n      }\n    }\n  }\n\n  @media(min-width: @md-screen) {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    .carousel-content {\n      animation: right_opacity_exit .6s 1;\n\n      &.visible-content {\n        animation: right_opacity_entry .6s 1;\n      }\n    }\n  }\n\n  @media(max-width: @md-screen) {\n    padding: 1.4rem 0;\n\n    .carousel-content {\n      padding: 0 1rem;\n\n      height: 0;\n      overflow: hidden;\n\n      &.visible-content {\n        position: inherit;\n        height: fit-content;\n      }\n    }\n  }\n  \n  .password-step-divider {\n    border-top-color: #cccccc;\n\n    .ant-divider-inner-text {\n      font-weight: 500;\n      font-size: .875rem;\n    }\n  }\n}\n\n@keyframes opacity_start {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes opacity_entry {\n  0% {\n    opacity: 0;\n  }\n  30% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes right_opacity_entry {\n  0% {\n    opacity: 0;\n    transform: translateX(11rem);\n  }\n  30% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0rem);\n  }\n}\n@keyframes right_opacity_exit {\n  0% {\n    opacity: 1;\n    transform: translateX(0rem);\n  }\n  70% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-11rem);\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
